module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-main",
      "data-tabs": "tabs"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "pill"
    },
    on: {
      "click": function($event) {
        return _vm.selectApplicantTab()
      }
    }
  }, [_vm._v("Applicant")])]), _vm._v(" "), _vm._l((_vm.visibleLicenceActivities), function(activity, index) {
    return _c('li', {
      key: ("issue_activity_tab_" + index),
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link",
      attrs: {
        "data-toggle": "pill"
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(activity)
        }
      }
    }, [_vm._v(_vm._s(activity.name))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, _vm._l((_vm.selectedActivity), function(item, index) {
    return _c('div', {
      key: ("issue_activity_content_" + index),
      staticClass: "row"
    }, [_c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h3', {
      staticClass: "panel-title"
    }, [_vm._v("Issue/Decline - " + _vm._s(item.name) + "\n                        "), _c('a', {
      staticClass: "panelClicker",
      attrs: {
        "href": '#' + _vm.panelBody,
        "data-toggle": "collapse",
        "data-parent": "#userInfo",
        "expanded": "false",
        "aria-controls": _vm.panelBody
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-down pull-right "
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body panel-collapse collapse in",
      attrs: {
        "id": _vm.panelBody
      }
    }, [_c('form', {
      staticClass: "form-horizontal",
      attrs: {
        "action": "index.html",
        "method": "post"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(0, true), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, _vm._l((_vm.applicationSelectedActivitiesForPurposes), function(p, index) {
      return _c('div', {
        key: ("p_" + index)
      }, [_c('div', {
        staticClass: "panel panel-primary"
      }, [_c('div', {
        staticClass: "panel-heading"
      }, [_c('h4', {
        staticClass: "panel-title"
      }, [_vm._v(_vm._s(p.purpose.short_name) + "\n                                                        "), _c('a', {
        staticClass: "panelClicker",
        attrs: {
          "href": "#" + index + _vm.purposeBody,
          "data-toggle": "collapse",
          "data-parent": "#userInfo",
          "expanded": "true",
          "aria-controls": _vm.purposeBody
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-chevron-down pull-right "
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body panel-collapse collapse",
        attrs: {
          "id": "" + index + _vm.purposeBody
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getPickedPurpose(p.purpose.id).isProposed),
          expression: "getPickedPurpose(p.purpose.id).isProposed"
        }],
        attrs: {
          "type": "radio",
          "id": p.purpose.id
        },
        domProps: {
          "value": true,
          "checked": _vm._q(_vm.getPickedPurpose(p.purpose.id).isProposed, true)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.getPickedPurpose(p.purpose.id), "isProposed", true)
          }
        }
      }), _vm._v(" Issue  \n                                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getPickedPurpose(p.purpose.id).isProposed),
          expression: "getPickedPurpose(p.purpose.id).isProposed"
        }],
        attrs: {
          "type": "radio",
          "id": p.purpose.id
        },
        domProps: {
          "value": false,
          "checked": _vm._q(_vm.getPickedPurpose(p.purpose.id).isProposed, false)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.getPickedPurpose(p.purpose.id), "isProposed", false)
          }
        }
      }), _vm._v(" Decline  \n                                                            ")]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        ref: ("start_date_" + (p.id)),
        refInFor: true,
        staticClass: "input-group date",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.proposed_start_date),
          expression: "p.proposed_start_date"
        }],
        staticClass: "form-control",
        attrs: {
          "readonly": p.processing_status !== 'reissue' && (!_vm.canEditLicenceDates && p.proposed_end_date),
          "type": "text",
          "name": ("start_date_" + (p.id)),
          "placeholder": "DD/MM/YYYY"
        },
        domProps: {
          "value": (p.proposed_start_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "proposed_start_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _vm._m(2, true)]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        ref: ("end_date_" + (p.id)),
        refInFor: true,
        staticClass: "input-group date",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.proposed_end_date),
          expression: "p.proposed_end_date"
        }],
        staticClass: "form-control",
        attrs: {
          "readonly": p.processing_status !== 'reissue' && (!_vm.canEditLicenceDates && p.proposed_end_date),
          "type": "text",
          "name": ("end_date_" + (p.id)),
          "placeholder": "DD/MM/YYYY"
        },
        domProps: {
          "value": (p.proposed_end_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "proposed_end_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _vm._m(3, true)]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-3"
      }, [_c('label', {
        staticClass: "control-label pull-left",
        attrs: {
          "for": "Name"
        }
      }, [_vm._v("Additional Fee")])]) : _vm._e(), _vm._v(" "), (_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.additional_fee),
          expression: "p.additional_fee"
        }],
        ref: "licence_fee",
        refInFor: true,
        staticClass: "form-control",
        staticStyle: {
          "width": "50%"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (p.additional_fee)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "additional_fee", $event.target.value)
          }
        }
      })]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-3"
      }, [_c('label', {
        staticClass: "control-label pull-left",
        attrs: {
          "for": "Name"
        }
      }, [_vm._v("Fee Description")])]) : _vm._e(), _vm._v(" "), (_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.additional_fee_text),
          expression: "p.additional_fee_text"
        }],
        staticClass: "form-control",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "type": "text",
          "name": "licence_fee_text_" + index
        },
        domProps: {
          "value": (p.additional_fee_text)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "additional_fee_text", $event.target.value)
          }
        }
      })]) : _vm._e()]), _vm._v(" "), _vm._l((p.purpose_species_json), function(free_text, pt_idx) {
        return _c('div', {
          key: ("pt_" + pt_idx)
        }, [_c('br'), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('div', {
          staticClass: "col-sm-3"
        }, [_c('label', {
          staticClass: "control-label pull-left",
          attrs: {
            "for": "Name"
          }
        }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (free_text.is_additional_info),
            expression: "free_text.is_additional_info"
          }]
        }, [_c('br'), _c('br'), _vm._v(" "), _c('input', {
          attrs: {
            "type": "checkbox",
            "checked": "",
            "disabled": ""
          }
        }), _vm._v(" "), _c('label', [_vm._v("Is additional info")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-9"
        }, [_c('ckeditor', {
          ref: "ap_text_detail",
          refInFor: true,
          attrs: {
            "config": _vm.editorConfig
          },
          model: {
            value: (free_text.details),
            callback: function($$v) {
              _vm.$set(free_text, "details", $$v)
            },
            expression: "free_text.details"
          }
        })], 1)])])
      }), _vm._v(" "), (!_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-12"
      }, [_vm._v("                                                        \n                                                             \n                                                        ")]) : _vm._e()], 2)])])])
    }), 0)]), _vm._v(" "), _vm._m(4, true), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    })])])])])]), _vm._v(" "), _c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h3', {
      staticClass: "panel-title"
    }, [_vm._v("Emailing\n                        "), _c('a', {
      staticClass: "panelClicker",
      attrs: {
        "href": '#' + _vm.emailPanelBody,
        "data-toggle": "collapse",
        "data-parent": "#userInfo",
        "expanded": "false",
        "aria-controls": _vm.emailPanelBody
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-down pull-right "
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body panel-collapse collapse in",
      attrs: {
        "id": _vm.emailPanelBody
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-9"
    }, [_c('div', {
      ref: "details",
      refInFor: true,
      staticClass: "input-group date",
      staticStyle: {
        "width": "70%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.getActivity(item.id).reason),
        expression: "getActivity(item.id).reason"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": "details"
      },
      domProps: {
        "value": (_vm.getActivity(item.id).reason)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.getActivity(item.id), "reason", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-9"
    }, [_c('div', {
      ref: "cc_email",
      refInFor: true,
      staticClass: "input-group date",
      staticStyle: {
        "width": "70%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.getActivity(item.id).cc_email),
        expression: "getActivity(item.id).cc_email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": "cc_email"
      },
      domProps: {
        "value": (_vm.getActivity(item.id).cc_email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.getActivity(item.id), "cc_email", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-9"
    }, [_c('filefield', {
      ref: "issuance_documents",
      refInFor: true,
      attrs: {
        "name": "issuance-documents",
        "isRepeatable": true,
        "documentActionUrl": _vm.applicationIssuanceDocumentUrl
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), (_vm.licence.activity.some(function (activity) { return activity.final_status === 'issued'; })) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Issue\n                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.issuePanelBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.issuePanelBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.issuePanelBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.isIdCheckAccepted) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckAwaitingUpdate) ? _c('label', [_vm._v("Awaiting update. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isIdNotChecked) ? _c('label', [_vm._v("Has not been accepted. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isIdNotChecked || _vm.isIdCheckAwaitingUpdate) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedItem('id_check').isChecked),
      expression: "getCheckedItem('id_check').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedItem('id_check').isChecked) ? _vm._i(_vm.getCheckedItem('id_check').isChecked, true) > -1 : (_vm.getCheckedItem('id_check').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedItem('id_check').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedItem('id_check'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedItem('id_check'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedItem('id_check'), "isChecked", $$c)
        }
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.isCharacterCheckAccepted) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.isCharacterNotChecked) ? _c('label', [_vm._v("Has not been accepted. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isCharacterNotChecked) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedItem('character_check').isChecked),
      expression: "getCheckedItem('character_check').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedItem('character_check').isChecked) ? _vm._i(_vm.getCheckedItem('character_check').isChecked, true) > -1 : (_vm.getCheckedItem('character_check').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedItem('character_check').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedItem('character_check'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedItem('character_check'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedItem('character_check'), "isChecked", $$c)
        }
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.isReturnCheckAccepted) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.isReturnCheckAwaitingReturns) ? _c('label', [_vm._v("Awaiting return. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isReturnNotChecked) ? _c('label', [_vm._v("Has not been accepted. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isReturnNotChecked || _vm.isReturnCheckAwaitingReturns) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedItem('return_check').isChecked),
      expression: "getCheckedItem('return_check').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedItem('return_check').isChecked) ? _vm._i(_vm.getCheckedItem('return_check').isChecked, true) > -1 : (_vm.getCheckedItem('return_check').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedItem('return_check').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedItem('return_check'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedItem('return_check'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedItem('return_check'), "isChecked", $$c)
        }
      }
    }
  }) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), ((_vm.applicantType == 'org' && _vm.application.org_applicant.address) ||
    (_vm.applicantType == 'proxy' && _vm.application.proxy_applicant.residential_address) ||
    (_vm.applicantType == 'submitter' && _vm.application.submitter.residential_address)) ? _c('p', [_vm._v("Click "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.preview()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to preview the licence document.")]) : _c('p', [_vm._v("Preview not available - applicant address not set")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [(_vm.canIssueOrDecline) ? _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Issue/Decline")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ok()
      }
    }
  }, [_vm._v("Issue/Decline")])])]) : _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ok()
      }
    }
  }, [_vm._v("Issue/Decline")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Proposed Purposes:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("CC Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Files to be attached to email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("ID Check")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Character Check")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Return Check")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-520803dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/applications/application_issuance.vue
// module id = 975
// module chunks = 0